import { ReactNode } from "react";

import Button from "./Button";
import Modal from "./Modal";

interface ConfirmModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  icon?: ReactNode;
  confirmText?: string;
  cancelText?: string;
  children?: ReactNode;
  zIndex?: number;
}

const ConfirmModal = ({
  show,
  onClose,
  onConfirm,
  title,
  icon,
  confirmText = "OK",
  cancelText = "キャンセル",
  children,
  zIndex
}: ConfirmModalProps) => {
  const actions = (
    <>
      <Button onClick={onConfirm} variant="primary">
        {confirmText}
      </Button>
      <Button onClick={onClose} variant="secondary">
        {cancelText}
      </Button>
    </>
  );

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={title}
      icon={icon}
      actions={actions}
      zIndex={zIndex}
    >
      {children}
    </Modal>
  );
};

export default ConfirmModal;